import { css /*Interpolation, Theme*/ } from "@emotion/react";
import { useId } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const formatPhoneNumber = (value: string) => {
	const digits: string[] = [];
	for (let i = 0; i < value.length; i += 1) {
		const ch = value[i];
		if (ch >= "0" && ch <= "9") {
			if (digits.length === 0 && ch === "0") {
				continue;
			}
			if (digits.length < 10) {
				digits.push(ch);
			}
		}
	}

	if (digits.length === 0) {
		return "";
	}

	let out = `(${digits[0]}`;
	if (digits.length >= 2) {
		out += digits[1];
	}
	if (digits.length >= 3) {
		out += `${digits[2]}) `;
	} else {
		return out;
	}

	if (digits.length >= 4) {
		out += digits[3];
	}
	if (digits.length >= 5) {
		out += digits[4];
	}
	if (digits.length >= 6) {
		out += digits[5];
	}
	if (digits.length >= 6) {
		out += "-";
	}
	if (digits.length >= 7) {
		out += digits[6];
	}
	if (digits.length >= 8) {
		out += digits[7];
	}
	if (digits.length >= 9) {
		out += digits[8];
	}
	if (digits.length >= 10) {
		out += digits[9];
	}

	return out;
};

type FwPhoneNumberBoxProps = {
	value: string;
	onChange: (event: { currentTarget: { value: string } }) => void;
	label: string;
	required?: boolean;
};

const FwPhoneNumberBox: React.FC<FwPhoneNumberBoxProps> = (props) => {
	const inputId = useId();

	return (
		<div css={css`margin: .5rem 0 0 0; width: 100%;`}>
			<Label className="mb-1 inline-block" htmlFor={inputId}>
				{props.label}
				{props.required && (
					<>
						{" "}
						<span className="text-destructive">*</span>
					</>
				)}
			</Label>
			<Input
				id={inputId}
				type="tel"
				required={props.required ?? false}
				value={formatPhoneNumber(props.value)}
				inputMode="tel"
				onChange={(event) => {
					props.onChange({
						currentTarget: {
							value: formatPhoneNumber(event.currentTarget.value),
						},
					});
				}}
			/>
		</div>
	);
};

export default FwPhoneNumberBox;
